/* eslint-disable import/no-anonymous-default-export */
import { combineReducers } from "redux";
import configureStore from "./createStore";
import rootSaga from "./sagas";
import homePageReducer from "./reducers/homePageReducer";
import orderPageReducer from "./reducers/orderPageReducer";
import globalReducer from "./reducers/globalReducer";
import specialOfferPageReducer from "./reducers/specialOfferPageReducer";
import infomationStorePageReducer from "./reducers/infomationStorePageReducer";
import giftExchangePageReducer from "./reducers/giftExchangePageReducer";
import infoLoyaltyPageReducer from "./reducers/infoLoyaltyPageReducer";
import programDetailReducer from "./reducers/programDetailReducer";
import notificationPageReducer from "./reducers/notificationPageReducer";
import signaturePageReducer from "./reducers/signaturePageReducer";
import gamePageReducer from "./reducers/gamePageReducer";
import { persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";

const authPersistConfig = {
	key: "carts",
	storage: storage
};

const programDetailPersistConfig = {
	key: "programDetail",
	storage: storage
};

export default () => {
	const rootReducer = combineReducers({
		orderPageReducer: persistReducer(authPersistConfig, orderPageReducer),
		programDetailReducer: persistReducer(
			programDetailPersistConfig,
			programDetailReducer
		),
		homePageReducer,
		globalReducer,
		specialOfferPageReducer,
		infomationStorePageReducer,
		giftExchangePageReducer,
		notificationPageReducer,
		infoLoyaltyPageReducer,
		signaturePageReducer,
		gamePageReducer
	});

	return configureStore(rootReducer, rootSaga);
};
